import React from 'react'
import Navbar from '../global-components/navbar'
import SellPropertyPage from './sellPropertyPage'
import GetInTouch from '../../utils/getInTouch'
import Footer_v1 from '../global-components/footer'
import PageHeaderSell from './sellHeader'
import BlogContact from '../../utils/blogContact'
const sellMain = () => {
  return (
    <div>
      < Navbar/>
     < PageHeaderSell headertitle="Sell" />
      < SellPropertyPage />
      < BlogContact/>
      <Footer_v1/>
    </div>
  )
}

export default sellMain
